import { render, staticRenderFns } from "./editNews.vue?vue&type=template&id=6f9c6fec&scoped=true&"
import script from "./editNews.vue?vue&type=script&lang=js&"
export * from "./editNews.vue?vue&type=script&lang=js&"
import style0 from "./editNews.vue?vue&type=style&index=0&id=6f9c6fec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9c6fec",
  null
  
)

export default component.exports